"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var CaseMultipleChoiceCardWrapper = function CaseMultipleChoiceCardWrapper(Component) {
  var _class, _class2, _descriptor;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this$props$card, _this$props$cardState;
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "selectedCase", _descriptor, _this);
      _this.resetSelection = function () {
        _this.clearCheckAnswerTimeout();
        _this.clearSelectedCaseTimeout();
        _this.selectedCase = null;
      };
      _this.clearCheckAnswerTimeout = function () {
        if (_this.checkAnswerTimeout) {
          clearTimeout(_this.checkAnswerTimeout);
          _this.checkAnswerTimeout = null;
        }
      };
      _this.clearSelectedCaseTimeout = function () {
        if (_this.selectedCaseTimeout) {
          clearTimeout(_this.selectedCaseTimeout);
          _this.selectedCaseTimeout = null;
        }
      };
      _this.onSelectCase = function (caseItem) {
        if (_this.props.cardState.revealed || _this.props.cardState.pendingReveal) {
          return;
        }
        _this.selectedCase = caseItem.id;
        _this.props.cardState.selectedCase = caseItem.label;
        _this.props.cardState.selectedOptionText = caseItem.label;
        _this.clearCheckAnswerTimeout();
        _this.checkAnswerTimeout = setTimeout(function () {
          return _this.onCheckAnswer();
        }, 100);
      };
      _this.onCheckAnswer = function () {
        _this.checkAnswerTimeout = null;
        if (_this.props.cardState.revealed || !_this.selectedCase) {
          return;
        }
        if (_this.selectedCase === _this.correctCase) {
          _state.DeckUI.onCorrectAnswer(_this.props.card, _this.props.cardState, _this.props.userCard, {
            xp: 2,
            xpSlug: 'case'
          });
        } else {
          _state.DeckUI.onIncorrectAnswer(_this.props.card, _this.props.cardState, _this.props.userCard);
        }
        _state.DeckUI.reveal(_this.props.card, _this.props.cardState);
      };
      _this.onNextClick = function () {
        var _DeckUI$currentCard;
        var cardId = _this.props.card.id;
        _this.clearSelectedCaseTimeout();
        _state.DeckUI.advanceCard(_this.props.card, _this.props.cardState, _this.props.userCard);
        if (((_DeckUI$currentCard = _state.DeckUI.currentCard) === null || _DeckUI$currentCard === void 0 ? void 0 : _DeckUI$currentCard.id) === cardId) {
          _this.resetSelection();
          return;
        }
        _this.selectedCaseTimeout = setTimeout(function () {
          _this.selectedCase = null;
          _this.selectedCaseTimeout = null;
        }, 2000);
      };
      _state.DeckUI.enrichSentence(_this.props.card);
      _this.lastCardId = (_this$props$card = _this.props.card) === null || _this$props$card === void 0 ? void 0 : _this$props$card.id;
      _this.lastRevealed = Boolean((_this$props$cardState = _this.props.cardState) === null || _this$props$cardState === void 0 ? void 0 : _this$props$cardState.revealed);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var _this$props$card2, _this$props$cardState2, _this$props$card3, _this$props$cardState3;
        if (this.lastCardId !== ((_this$props$card2 = this.props.card) === null || _this$props$card2 === void 0 ? void 0 : _this$props$card2.id)) {
          this.resetSelection();
        } else if (this.lastRevealed && !((_this$props$cardState2 = this.props.cardState) !== null && _this$props$cardState2 !== void 0 && _this$props$cardState2.revealed)) {
          this.resetSelection();
        }
        this.lastCardId = (_this$props$card3 = this.props.card) === null || _this$props$card3 === void 0 ? void 0 : _this$props$card3.id;
        this.lastRevealed = Boolean((_this$props$cardState3 = this.props.cardState) === null || _this$props$cardState3 === void 0 ? void 0 : _this$props$cardState3.revealed);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.clearCheckAnswerTimeout();
        this.clearSelectedCaseTimeout();
      }
    }, {
      key: "selectedWordAssociation",
      get: function get() {
        var _this$props$card$sent,
          _this2 = this;
        if (!((_this$props$card$sent = this.props.card.sentence) !== null && _this$props$card$sent !== void 0 && _this$props$card$sent.wordAssociations)) return null;
        return this.props.card.sentence.wordAssociations.find(function (wa) {
          return _this2.props.card.wordAssociationIds.includes(wa.id);
        });
      }
    }, {
      key: "selectedWord",
      get: function get() {
        var _this$selectedWordAss;
        return (_this$selectedWordAss = this.selectedWordAssociation) === null || _this$selectedWordAss === void 0 ? void 0 : _this$selectedWordAss.word;
      }
    }, {
      key: "selectedPhrase",
      get: function get() {
        var _this$props$card$sent2,
          _this3 = this;
        if (!this.props.card.nounPhraseWordAssociationIds || !((_this$props$card$sent2 = this.props.card.sentence) !== null && _this$props$card$sent2 !== void 0 && _this$props$card$sent2.wordAssociations)) return null;
        var phraseWordAssociations = this.props.card.sentence.wordAssociations.filter(function (wa) {
          return _this3.props.card.nounPhraseWordAssociationIds.includes(wa.id);
        }).sort(function (a, b) {
          return a.position - b.position;
        });
        var phrase = phraseWordAssociations.map(function (wa) {
          return wa.targetText;
        }).filter(Boolean).join(' ');
        if (!phrase) return '';
        return phrase.charAt(0).toUpperCase() + phrase.slice(1);
      }
    }, {
      key: "prompt",
      get: function get() {
        return "What is the case of the highlighted word".concat((0, _utils.isPresent)(this.props.card.nounPhraseWordAssociationIds) && this.props.card.nounPhraseWordAssociationIds.length > 1 ? 's' : '', "?");
      }
    }, {
      key: "mediaSectionHeight",
      get: function get() {
        return _state.DeckUI.layout.heightForCardSections(3, 0, false);
      }
    }, {
      key: "sectionHeight",
      get: function get() {
        if (this.props.cardState.revealed) {
          return _state.DeckUI.layout.heightForCardSections(3, 0, false);
        }
        return _state.DeckUI.layout.contentHeightWithMultipleChoiceButtons(4) - this.mediaSectionHeight;
      }
    }, {
      key: "caseOptions",
      get: function get() {
        return [{
          id: 'nominative',
          label: 'Nominative',
          correct: this.correctCase === 'nominative',
          backgroundColor: _constants.Theme.gray,
          textColor: '#FFF'
        }, {
          id: 'accusative',
          label: 'Accusative',
          correct: this.correctCase === 'accusative',
          backgroundColor: _constants.Theme.caseColors.accusative,
          textColor: '#FFF'
        }, {
          id: 'dative',
          label: 'Dative',
          correct: this.correctCase === 'dative',
          backgroundColor: _constants.Theme.caseColors.dative,
          textColor: '#FFF'
        }, {
          id: 'genitive',
          label: 'Genitive',
          correct: this.correctCase === 'genitive',
          backgroundColor: _constants.Theme.caseColors.genitive,
          textColor: '#FFF'
        }];
      }
    }, {
      key: "correctAnswerBackgroundColor",
      get: function get() {
        return _constants.Theme.caseColors[this.correctCase];
      }
    }, {
      key: "caseSlugFromConcepts",
      value: function caseSlugFromConcepts(concepts) {
        if (!concepts || !concepts.length) return null;
        if (concepts.find(function (item) {
          return item.grammarCase === 'Nm' || item.isNominative;
        })) return 'nominative';
        if (concepts.find(function (item) {
          return item.grammarCase === 'Gn' || item.isGenitive;
        })) return 'genitive';
        if (concepts.find(function (item) {
          return item.grammarCase === 'Dt' || item.grammarCase === '2w-Dt' || item.isDative;
        })) return 'dative';
        if (concepts.find(function (item) {
          return item.grammarCase === 'Ak' || item.grammarCase === '2w-Ak' || item.isAccusative;
        })) return 'accusative';
        return null;
      }
    }, {
      key: "correctCase",
      get: function get() {
        var _this$selectedWordAss2;
        var fromWordAssociation = this.caseSlugFromConcepts((_this$selectedWordAss2 = this.selectedWordAssociation) === null || _this$selectedWordAss2 === void 0 ? void 0 : _this$selectedWordAss2.concepts);
        if (fromWordAssociation) return fromWordAssociation;
        if (!this.selectedWord) return null;
        if (this.selectedWord.isNominative) return 'nominative';
        if (this.selectedWord.isGenitive) return 'genitive';
        if (this.selectedWord.isDative) return 'dative';
        if (this.selectedWord.isAccusative) return 'accusative';
        return this.caseSlugFromConcepts(this.props.card.concept ? [this.props.card.concept] : []);
      }
    }, {
      key: "correctCaseDisplay",
      get: function get() {
        if (!this.correctCase) return null;
        return (0, _lodash.startCase)(this.correctCase);
      }
    }, {
      key: "selectedCaseDisplay",
      get: function get() {
        if (!this.selectedCase) return null;
        return (0, _lodash.startCase)(this.selectedCase);
      }
    }, {
      key: "correctMessage",
      get: function get() {
        return {
          prefix: "Correct! \"".concat(this.selectedPhrase, "\" is "),
          caseName: this.correctCaseDisplay
        };
      }
    }, {
      key: "incorrectMessage",
      get: function get() {
        return {
          prefix: "\"".concat(this.selectedPhrase, "\" is "),
          caseName: this.correctCaseDisplay
        };
      }
    }, {
      key: "currentMessage",
      get: function get() {
        return this.props.userCard.correct ? this.correctMessage : this.incorrectMessage;
      }
    }, {
      key: "possibleArrowBoxes",
      get: function get() {
        return ['caseClickOnWord', 'caseUnderline'];
      }
    }, {
      key: "currentArrowBox",
      get: function get() {
        var arrowBox;
        if (this.props.cardState.revealed) {
          (0, _lodash.each)(this.possibleArrowBoxes, function (slug) {
            if (!_state.DeckUI.user.wasUiElementSeen(slug)) {
              arrowBox = slug;
            }
          });
        }
        return arrowBox;
      }
    }, {
      key: "icons",
      get: function get() {
        var ary = [];
        if ((0, _utils.isPresent)(this.props.card.grammarTip)) {
          ary.push('grammarTip');
        }
        if (_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (!_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('toggleReview');
        }
        if (this.props.cardState.revealed) {
          ary.push('cardComments');
        }
        if (_state.DeckUI.reviewDeck && (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal)) {
          ary.push('cardNote');
        }
        ary.push('languageButton');
        return ary;
      }
    }, {
      key: "grammarHint",
      get: function get() {
        return _state.DeckUI.getCaseGrammarHint(this.props.card, this.props.cardState);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          sectionHeight: this.sectionHeight,
          mediaSectionHeight: this.mediaSectionHeight,
          caseOptions: this.caseOptions,
          selectedCase: this.selectedCase,
          correctCase: this.correctCase,
          correctCaseDisplay: this.correctCaseDisplay,
          selectedCaseDisplay: this.selectedCaseDisplay,
          icons: this.icons,
          onSelectCase: this.onSelectCase,
          onCheckAnswer: this.onCheckAnswer,
          onNextClick: this.onNextClick,
          prompt: this.prompt,
          selectedWord: this.selectedWord,
          correctMessage: this.correctMessage,
          incorrectMessage: this.incorrectMessage,
          currentMessage: this.currentMessage,
          correctAnswerBackgroundColor: this.correctAnswerBackgroundColor,
          possibleArrowBoxes: this.possibleArrowBoxes,
          currentArrowBox: this.currentArrowBox,
          grammarHint: this.grammarHint
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "selectedCase", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "selectedWordAssociation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedWordAssociation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedWord", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedWord"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedPhrase", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedPhrase"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "prompt", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "prompt"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mediaSectionHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "mediaSectionHeight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sectionHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sectionHeight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "caseOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "caseOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctAnswerBackgroundColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctAnswerBackgroundColor"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctCase", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctCase"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctCaseDisplay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctCaseDisplay"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedCaseDisplay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedCaseDisplay"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "incorrectMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "incorrectMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "currentMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "possibleArrowBoxes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "possibleArrowBoxes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentArrowBox", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "currentArrowBox"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "grammarHint", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "grammarHint"), _class2.prototype), _class2)) || _class;
};
CaseMultipleChoiceCardWrapper.displayName = 'CaseMultipleChoiceCardWrapper';
var _default = exports["default"] = CaseMultipleChoiceCardWrapper;